import { render, staticRenderFns } from "./EmployeeDetail.vue?vue&type=template&id=c99ad8c8&scoped=true&"
import script from "./EmployeeDetail.js?vue&type=script&lang=js&"
export * from "./EmployeeDetail.js?vue&type=script&lang=js&"
import style0 from "./EmployeeDetail.scss?vue&type=style&index=0&id=c99ad8c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99ad8c8",
  null
  
)

export default component.exports